module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "annual-norm text-dark"
  }, [_c('div', {
    staticClass: "d-header"
  }, [_c('div', {
    staticClass: "d-header__left"
  }, [_c('h1', [_vm._v("Arbeidstidsplan")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
    staticClass: "d-tabs"
  }, [_c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': !_vm.viewIsResult
    },
    on: {
      "click": function($event) {
        _vm.viewIsResult = false
      }
    }
  }, [_vm._v("\n        Arbeidsåret\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__container"
  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": _vm.userWithProps
    }
  })] : _c('div', {
    staticClass: "annual-norm__body"
  }, [_c('div', {
    staticClass: "annual-norm__body__left"
  }, [_c('ArbeidsplanAssignHoursNorm', {
    staticClass: "marg-1-bottom",
    on: {
      "updateUsersHours": _vm.readAssignedHours
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
    return _c('li', {
      key: user.user_calendar_id,
      staticClass: "user-item",
      class: {
        'user-item--active': user.v_is_active_user
      }
    }, [_c('div', {
      staticClass: "user-item__body",
      on: {
        "click": function($event) {
          return _vm.setActiveUserId(user.id)
        }
      }
    }, [_c('div', {
      staticClass: "user-item__name"
    }, [(user.default_thumb_url) ? _c('img', {
      staticClass: "user-item__name__img",
      attrs: {
        "src": user.default_thumb_url
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
      staticClass: "user-item__right"
    }, [_c('div', {
      staticClass: "user-item__hours"
    }, [_c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Årsverk")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Undervisning")]), _c('span', [_vm._v(_vm._s(user.v_total_teaching_percentage_label))])]), _vm._v(" "), _c('p', [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Oppgaver")]), _c('span', [_vm._v(_vm._s(user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('div', {
      staticClass: "user-item__arrow"
    }, [(!user.v_is_active_user) ? _c('span', {
      staticClass: "icon-arrow-right4"
    }) : _c('span', {
      staticClass: "icon-arrow-down4"
    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('ArbeidsplanUser', {
      attrs: {
        "user": _vm.activeUser,
        "activeNorm": _vm.activeNorm,
        "activeNormFormatted": _vm.activeNormFormatted
      }
    }) : _vm._e()], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "annual-norm__body__right"
  }, [_c('div', {
    staticClass: "annual-norm__body__right__header"
  }, [_c('div', {
    staticClass: "flipper-buttons"
  }, [_c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': !_vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-year-planning"
  }), _vm._v("\n                Fag\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': _vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-text"
  }), _vm._v("\n                Oppgaver\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('ArbeidsplanSubjects', {
    on: {
      "setIsCreate": _vm.setIsCreateSubject,
      "setEditSubject": _vm.setEditSubject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('SubjectsDistributionTasks') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "initCalendarId": _vm.activeCalendarId,
      "editSubject": _vm.theEditSubject,
      "editSubjectId": _vm.theEditSubjectId
    },
    on: {
      "close": _vm.closeSubjectModal,
      "createSubject": _vm.createNewSubject,
      "updateSubject": _vm.updateSubject,
      "deleteSubject": _vm.deleteSubject
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('setConfirmDeletion', false)
      },
      "confirm": _vm.confirmDelete
    }
  }, [_c('h3', {
    staticStyle: {
      "padding": "1rem 1rem 0 1rem"
    },
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a5c1e24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arbeidsplan/Arbeidsplan.vue
// module id = 1556
// module chunks = 1